// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1g9x_","balanceDisclaimer":"posDashboard_balanceDisclaimer__1-ePE"};